import { SxStyles } from '../../../../../types';

export const styles: SxStyles = {
  perimeterWrapper: {
    display: 'flex',
    flexDirection: 'column',
    width: { sm: '150px', lg: '210px' },
    '& .MuiInputBase-root': { pl: { sm: 0 } },
    '& .MuiInputBase-root > .MuiSvgIcon-root': { display: { sm: 'none' } },
    '& .MuiFormControl-root': { height: '100%' },
  },
};
